<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      style="
        display: block;
        position: absolute;
        overflow: auto;
        border: none;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
      "
      :src="url"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentLang', 'selectedBot']),
    url() {
      const tempUrl = new URL(`https://line-rich-menu.enterprise.zwiz.app/${this.currentLang}`)
      tempUrl.searchParams.set('page_id', this.selectedBot.pageid)
      return tempUrl.toString()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LineRichMenu/index.vue